import { ApiService } from "./apiService";

export class SettoriService {
  static async createSettore(
    competitionId: number,
    nome: string
  ): Promise<{ id: number; name: string; competitionId: number }> {
    // L'endpoint ora richiede l'id della gara nella url e il nome nel body
    return ApiService.client.post<{
      id: number;
      name: string;
      competitionId: number;
    }>(`/Competitions/${competitionId}/Sections`, { name: nome });
  }

  static async editSettore(
    sectionId: number,
    name: string
  ) {

    return ApiService.client.put(`/Sections/${sectionId}?name=${encodeURIComponent(name)}`, {});
  }

    static async deleteSettore(
    sectionId: number
  ) {

    return ApiService.client.delete(`/Sections/${sectionId}`);
  }
}
